import {Component, OnInit, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NotificationService} from "../../services/notification/notification.service";
import {
  RateNotificationDialogContentComponent
} from "../../services/notification/notification-dialog-content/rate-notification-dialog-content/rate-notification-dialog-content.component";
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'homey-review-page',
  standalone: true,
  imports: [],
  template: '',
})
export class ReviewPageComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly notificationService = inject(NotificationService);
  private dialogRef: DynamicDialogRef | null = null;

  ngOnInit(): void {
    const anonymousId = this.route.snapshot.queryParamMap.get('id');

    if (!anonymousId) {
      void this.router.navigate(['/']);
      return;
    }

    this.dialogRef = this.notificationService.openNotificationDialog([{
      disableContinue: true,
      component: RateNotificationDialogContentComponent,
      data: {
        anonymousId
      },
    }]);

    this.dialogRef?.onClose.subscribe(() => {
      void this.router.navigate(['/'], {replaceUrl: true});
    });
  }
}
